import { Box, Spinner } from '@amzn/awsui-components-core';
import React, { useEffect } from 'react';

import { useAuth } from '../../contexts/AuthContext';

/**
 * Component displayed when user is not authenticated
 * Automatically triggers sign-in process and shows loading state
 */
const UnauthenticatedMessage: React.FC = () => {
  const { signIn } = useAuth();

  // Automatically trigger sign-in when component mounts - no button needed
  useEffect(() => {
    const initiateSignIn = async (): Promise<void> => {
      try {
        await signIn();
      } catch {
        // Silent failure - federation redirects handle this
        setTimeout(() => {
          // If sign in fails, retry after a short delay
          void initiateSignIn();
        }, 1000);
      }
    };

    // Start the sign-in process immediately
    void initiateSignIn();
  }, [signIn]);

  return (
    <Box margin="xxl" padding="xxl" textAlign="center" data-testid="unauthenticated-message">
      <Spinner size="large" data-testid="loading-spinner" />
    </Box>
  );
};

export default UnauthenticatedMessage;
